import { createFileRoute } from '@tanstack/react-router'
import { Upload } from 'lucide-react'
import { isFeatureEnabled } from '@/lib/feature-flags'
import { GatedFeaturePlaceholder } from '@/components/GatedFeaturePlaceholder'
import ErrorFallback from '@/components/ErrorFallback'
import { EmptyState } from '@/components/ui/empty-state'
import { PageBody, PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'

export const Route = createFileRoute('/_authenticated/uploads')({
  component: UploadsPage,
  errorComponent: ErrorFallback,
})

export function UploadsPage() {
  if (!isFeatureEnabled('uploads_previews')) {
    return (
      <GatedFeaturePlaceholder
        title="Uploads"
        description="A dedicated surface for managing uploaded documents with rich previews and cross-project reuse."
        icon={Upload}
        flagName="VITE_FF_UPLOADS_PREVIEWS"
        backTo="/docfiller"
      />
    )
  }
  return <UploadsEnabled />
}

function UploadsEnabled() {
  return (
    <PageContainer>
      <PageHeader
        eyebrow="Library"
        title="Uploads"
        description="All documents you have uploaded. Reuse them across fills without re-uploading."
      />
      <PageBody>
        <EmptyState
          icon={Upload}
          title="No uploads yet"
          description="Upload a document from the Doc Filler page. It will appear here for reuse."
        />
      </PageBody>
    </PageContainer>
  )
}
